// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"a196470b","97":"7e084af1","259":"d9c6000a","271":"77fbf5e4","298":"4935156f","396":"e31199b2","464":"c4c2a4c9","578":"c2b63334","595":"e59d749d","656":"0eb5e789","788":"0b154db4","819":"87860c02","921":"f6b86e98","958":"8e36accf"}[chunkId] + ".chunk.js";
};